<div class="admin-hub main-content no-sidebar">
  <main class="workspace" id="main-content">
    <div class="workspace-header">
      <h1>{{ pageTitle }}</h1>
      <p>{{ pageSubtitle }}</p>
    </div>

    <nav class="admin-tabs" id="tour-target-admin-tabs" aria-label="Acciones de administración">
      <button
        type="button"
        class="admin-tab"
        *ngFor="let tab of tabs"
        [class.active]="activeTab === tab.id"
        [attr.aria-pressed]="activeTab === tab.id"
        (click)="selectTab(tab.id)">
        <span class="admin-tab-icon" aria-hidden="true"><i [class]="tab.icon"></i></span>
        <span class="admin-tab-copy">
          <span class="admin-tab-label">{{ tab.label }}</span>
          <span class="admin-tab-desc">{{ tab.desc }}</span>
        </span>
      </button>
    </nav>

    <div class="admin-tab-panel" [attr.data-tab]="activeTab">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
